
// 下拉页面——主流程
const MainRoutes = Array.from({ length: 6 }, (_, i) => ({
  path: `page/dropDown/index${i + 1}`,
  name: `page/dropDownIndex${i + 1}`,
  component: () => import(`@/views/recognize/page/dropDown/index${i + 1}.vue`)
}))

export default {
  path: '/recognize',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [

    // 下拉页面——主流程，开始
    ...MainRoutes
  ]
}
